import {
  Children,
  cloneElement,
  isValidElement,
  type CSSProperties,
  type ReactNode,
} from "react";

export function Stagger({
  children,
  className,
  start = 0,
}: {
  children: ReactNode;
  className?: string;
  start?: number;
}) {
  return (
    <div className={className}>
      {Children.map(children, (child, index) => {
        if (!isValidElement<{ className?: string; style?: CSSProperties }>(child)) {
          return child;
        }
        return cloneElement(child, {
          className: ["stagger-item", child.props.className].filter(Boolean).join(" "),
          style: {
            ...child.props.style,
            ["--stagger" as string]: start + index,
          },
        });
      })}
    </div>
  );
}
